import { render, staticRenderFns } from "./Parametros.vue?vue&type=template&id=5e452442&scoped=true"
import script from "./Parametros.vue?vue&type=script&lang=js"
export * from "./Parametros.vue?vue&type=script&lang=js"
import style0 from "./Parametros.vue?vue&type=style&index=0&id=5e452442&prod&scoped=true&lang=css"
import style1 from "./Parametros.vue?vue&type=style&index=1&id=5e452442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e452442",
  null
  
)

export default component.exports